import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../../settings/config.json';

function Admin_Messages() {
  const [messages, setMessages] = useState([]);
  const [bestMessage, setBestMessage] = useState(null);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get(`/api/messages`);
        setMessages(response.data);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchMessages();
    
    const interval = setInterval(fetchMessages, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleToggleLike = async (id) => {
    try {
      await axios.patch(`/api/messages/${id}/like`);
      setMessages(messages.map(message => 
        message._id === id ? { ...message, liked: !message.liked } : message
      ));
    } catch (error) {
      console.error('ERROR:', error);
    }
  };

  const fetchBestMessage = async () => {
    try {
      const response = await axios.get(`/api/messages/bestMsg`);
      setBestMessage(response.data);
    } catch (error) {
      console.error('ERROR:', error);
    }
  };

  const handleSetBest = async (id) => {
    try {
      await axios.patch(`/api/messages/${id}/best`);
      setMessages(messages.map(message => 
        message._id === id ? { ...message, best: !message.best } : { ...message, best: false }
      ));
    } catch (error) {
      console.error('ERROR:', error);
    }
  };


  useEffect(() => {
    fetchBestMessage();
  }, []);

  return (
    <div className='Messages'>
      {messages.length > 0 ? (
        <ul className='message-list'>
          {messages.map(message => (
            <li key={message._id} className='message-item'>
              {message.imagePath && (
                <img 
                  src={`/api${message.imagePath}`}
                  alt="Avatar" 
                  className='avatar mt-3'
                />
              )}
              <div className='message-details'>
                <p className='name text-white'>{message.name}</p>
                <p className='email text-light'>{message.email}</p>
                <p className='email text-gradient-two'>{message.phone}</p>
                <p className='message-content font-reqular text-white-50 spaces'>Mesaj: <br /><p className='text-white font-reqular'>{message.message}</p></p>
                <p className='date'>{new Date(message.date).toLocaleString()}</p>
              </div>
              <button 
                onClick={() => handleToggleLike(message._id)}
                className='like-button me-2'
              >
                <i className={`fa-heart fs-3 ${message.liked ? 'fa-solid text-danger' : 'fa-regular text-secondary'}`}></i>
              </button>
              <button 
                onClick={() => handleSetBest(message._id)}
                className='star-button'
              >
                <i className={`fa-star fs-3 ${message.best ? 'fa-solid text-warning' : 'fa-regular text-secondary'}`}></i>
              </button>
              <hr />
            </li>
          ))}
        </ul>
      ) : (
        <center className='mt-5'>
          <h2 className='text-gradient'>Oops...</h2>
          <h4 className='mt-3 text-secondary font-reqular'>Mesaj yoxdur</h4>
          <br /><br /><br />
        </center>
      )}
    </div>
  );
}

export default Admin_Messages;